/**
 * interface for timeTracking object with different keys for start/end/nighttime/sunday etc.
 */
export interface TimeTracking {
  id: string;
  createDate: Date;
  userId: string;
  startTime: number;
  startDate: Date;
  endTime: number;
  endDate?: Date;
  drivingTimeArrival: number;
  drivingTimeDeparture: number;
  breakTime: number;
  totalWorkTime: number;
  comment: string;
  holidayTime: number;
  absenceReasonId?: string;
  referenceId?: string;
}

/**
 * Used to group times for months
 */
export interface MonthlyTimes {
  '0': number;
  '1': number;
  '2': number;
  '3': number;
  '4': number;
  '5': number;
  '6': number;
  '7': number;
  '8': number;
  '9': number;
  '10': number;
  '11': number;
}
/**
 * Keys to index monthlyTimes
 */
export type MonthKey = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11';
/**
 * interface for workTime to save including timeTracking object and aditional information
 */
export interface WorkTime {
  id: string;
  createDate: Date;
  timeTracking: TimeTracking;
  protocolId: string;
  includingApproach: boolean;
  includingDeparture: boolean;
  clientBreakTime: number;
  clientDrivingTime: number;
}

/**
 * Defines the days of the week. According to the java.time.DayOfWeek the days
 * are 1 based
 */
export enum DayOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}
